//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'FIB_4',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
      },
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = (form.item1 * form.item2) / (form.item4 * Math.sqrt(form.item3))
        if (res <= 1.45) {
          self.text = '不考虑肝纤维化'
        } else if (res >= 3.25) {
          self.text = '高度怀疑肝纤维化'
        } else if (res > 1.45 && res < 3.25) {
          self.text = '需要进一步检查'
        }
        self.hasScore = true
        return String(res.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/FIB_4.vue